const supportSolutionsUrl = 'https://support.skynamo.com/support/solutions'

export const supportArticles = {
  supportDesk: supportSolutionsUrl,
  importingUserTargets: `${supportSolutionsUrl}/importing-user-targets-explained`,
  importingUserTargetActuals: `${supportSolutionsUrl}/import-user-target-actuals-explained`,
  subscriptionManagement: `${supportSolutionsUrl}/subscription-management`,
  multiFactorAuthentication: `${supportSolutionsUrl}/multi-factor-authentication-mfa-on-skynamo`,
  licenseChangeManagement: `${supportSolutionsUrl}/license-change-management`,
  rfmAnalysis: `${supportSolutionsUrl}/rfm-analysis-explained-web`,
} as const
